import { render } from "./webview.vue?vue&type=template&id=5057acae&scoped=true&bindings={}"
import script from "./webview.vue?vue&type=script&lang=ts"
export * from "./webview.vue?vue&type=script&lang=ts"

import "./webview.vue?vue&type=style&index=0&id=5057acae&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5057acae"

export default script